import { z } from 'zod/v4';

// JobCreateRequest
export const JobCreateRequestDTO = z.object({
  name: z.string(),
  config: z.string(),
  label: z.string(),
  tags: z.array(z.string()).optional(),
  vmagent_names: z.array(z.string()).optional(),
});
export type JobCreateRequest = z.infer<typeof JobCreateRequestDTO>;

// JobUpdateRequest
export const JobUpdateRequestDTO = z.object({
  config: z.string(),
  label: z.string(),
  tags: z.array(z.string()),
  vmagent_names: z.array(z.string()),
});
export type JobUpdateRequest = z.infer<typeof JobUpdateRequestDTO>;

// JobInfoResponse
export const JobDTO = z.object({
  id: z.uuid(),
  name: z.string(),
  config: z.string(),
  label: z.string(),
  tags: z.array(z.string()),
  vmagents: z
    .array(
      z.object({
        name: z.string(),
        label: z.string(),
      }),
    )
    .optional(),
});
export type Job = z.infer<typeof JobDTO>;